export const baseAPI = process.env.REACT_APP_BACKEND_URL;
export const websocketURL = process.env.REACT_APP_WEBSOCKET_URL;
export const registrationURL = process.env.REACT_APP_REGISTER_URL;

export const priorities = [
  "priority.no-prio",
  "priority.pregnancy",
  "priority.handicap",
  "priority.elderly",
  "priority.vip",
];

console.log(baseAPI, websocketURL,registrationURL );


if(!baseAPI || !websocketURL || !registrationURL) {
  console.error("Missing Env variables", "some functionality might not be working");
}

export const actualPriorities = [
  "Nessuna",
  "Gravidanza",
  "Disabilita",
  "> 65anni",
  "VIP",
];

export const getColors = (priority) => ([
  "#fff",
  "pink",
  "purple",
  "blue",
  "orangered",
][priority] || "#fff");

export const getControllerColors = (priority) => ([
  "#000",
  "pink",
  "purple",
  "blue",
  "orangered",
][priority] || "#000");

// console.log("ENVS", { baseAPI, websocketURL });
